var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-modal-camera-flow",
    {
      ref: "modalDamagesCamera",
      attrs: { type: "full" },
      on: { "modal:close": _vm.resetForms },
    },
    [
      !_vm.loading
        ? _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main view view--camera" },
              [
                _c("ma-notifications"),
                _c("ma-camera-with-steps", {
                  staticClass: "camera-with-steps",
                  attrs: { title: "Photos" },
                  on: { photosArray: _vm.handlePhotos },
                }),
              ],
              1
            ),
          ])
        : _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main has-modal" },
              [_c("maSpinner", { staticClass: "spinner" })],
              1
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }